<template>
  <el-dialog
      v-model="isShow"
      :title="'自定义指令'"
      :footer="null"
      centered
      top="8em"
      :width="800"
      style="min-width:300px;"
      :modal="true"
      @cancel="close"
      custom-class="dialog-class"
      :close-on-click-modal="false"
  >
    <template #default style="padding: 0px !important;">
      <div class="content-setting">
        <div class="title">您希望M·AI助手了解您的哪些方面一边提供更好的回复？</div>
        <div style="width: 100%">
          <el-popover
              placement="right"
              title="启发思考的提示"
              :width="200"
              trigger="click"
          >
            <template #default>
              <ul style="padding: 5px 20px 5px 20px">
                <li>您当前居住在哪里？</li>
                <li>您从事什么行业？</li>
                <li>您的爱好和兴趣是什么？</li>
                <li>您喜欢谈论哪些话题？</li>
                <li>您的目标是什么？</li>
              </ul>
            </template>
            <template #reference>
              <el-input
                  @keydown="(e) => e.stopPropagation()"
                  v-model="contentText1"
                  maxlength="1500"
                  style="width: 100%;resize:none;"
                  rows="8"
                  placeholder="请输入"
                  show-word-limit
                  type="textarea"
              />
            </template>
          </el-popover>
        </div>

        <div class="title">您希望M·AI如何进行回复？</div>
        <div style="width: 100%">
          <el-popover
              placement="right"
              title="启发思考的提示"
              :width="200"
              trigger="click"
          >
            <template #default>
              <ul style="padding: 5px 20px 5px 20px">
                <li>M·AI助手应采用正式还是随意的语气？</li>
                <li>一般来说，回复的篇幅应该短还是长？</li>
                <li>您希望的称呼是什么？</li>
                <li>M·AI助手应该对话题发表意见还是保持中立？</li>
              </ul>
            </template>
            <template #reference>
              <el-input
                  @keydown="(e) => e.stopPropagation()"
                  v-model="contentText2"
                  maxlength="1500"
                  style="width: 100%;resize:none;"
                  rows="8"
                  placeholder="请输入"
                  show-word-limit
                  type="textarea"
              />
            </template>
          </el-popover>
        </div>
      </div>
    </template>
    <template #footer>
      <div style="width: 100%;display: flex;justify-content: space-between;align-items: center">
        <div>
          <span style="margin-right: 10px">是否开启</span>
          <el-switch v-model="valueSwitch"/>
        </div>
        <div>
          <el-button @click="close">取消</el-button>
          <el-button type="primary">确定</el-button>
        </div>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import {ElButton, ElDialog, ElInput, ElMessage} from "element-plus";
import {ref, defineProps, watch, defineEmits, reactive, computed, onMounted} from 'vue'
import {useStore} from "vuex";
import {i18n} from "@/lang";
import DetailHistory from "@/components/DiaPops/AI/DetailHistory.vue";

const store = useStore();
const emit = defineEmits(['close'])
const isShow = ref(false);
const teamName = ref("")
const loading = ref(false);


const contentText1 = ref("")
const contentText2 = ref("")
const valueSwitch = ref(false)

const {value, isChecked} = defineProps({
  value: {type: Boolean, default: false},
  isChecked: {type: Array, default: []}
})

const visitableHistoryDetail = ref(false)
const closeDetail = () => {
  visitableHistoryDetail.value = false
}

const close = () => {
  emit('close')
}

watch(() => value, (val) => {
  isShow.value = val;
}, {immediate: true})

</script>

<style scoped lang="less">
.content-setting {
  .title {
    margin: 10px 0px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
  }
}


</style>